type CALCULATOR_OPTION = 'FIND_HIKE_PERCENTAGE' | 'FIND_NEW_SALARY';

export interface ISALARY_FORMULA {
  currentSalary: number | undefined;
  calculatorOption: CALCULATOR_OPTION | undefined;
  newSalary?: number | undefined;
  hikePercentage?: number | undefined;
}

type SALARY_HIKE_RESPONSE = {
  newSalaryOutput?: number | undefined;
  hikePercentageOutput?: number | undefined;
};

export const SALARY_CALCULATOR_FORMULA = ({
  currentSalary,
  newSalary,
  calculatorOption,
  hikePercentage,
}: ISALARY_FORMULA): SALARY_HIKE_RESPONSE => {
  if (
    !currentSalary ||
    Number(currentSalary) < 0 ||
    !calculatorOption ||
    (calculatorOption == 'FIND_HIKE_PERCENTAGE' &&
      (!newSalary || Number(newSalary) < 0)) ||
    (calculatorOption == 'FIND_NEW_SALARY' &&
      (!hikePercentage || Number(hikePercentage) < 0))
  ) {
    return {
      newSalaryOutput: 0,
      hikePercentageOutput: 0,
    };
  }

  if (calculatorOption == 'FIND_HIKE_PERCENTAGE' && newSalary) {
    return {
      hikePercentageOutput: ((newSalary - currentSalary) / currentSalary) * 100,
    };
  } else if (calculatorOption == 'FIND_NEW_SALARY' && hikePercentage) {
    return {
      newSalaryOutput:
        Number(hikePercentage / 100) * Number(currentSalary) +
        Number(currentSalary),
    };
  } else {
    return {
      newSalaryOutput: 0,
      hikePercentageOutput: 0,
    };
  }
};
